import { EnvironmentProviders } from '@angular/core';
import { getActionTypeFromInstance, withNgxsPlugin } from '@ngxs/store';

import { Logout } from '@data/state';

function logoutPlugin(state: any, action: any, next: any) {
    if (getActionTypeFromInstance(action) === Logout.type) {
        state = {
            auth: {
                token: null,
                expiration: null,
                refreshToken: null,
                refreshTokenExpiration: null,
                userName: null,
                firstName: null,
                lastName: null,
                email: null,
                role: null,
                roleType: null,
            },
            dashboard: {
                data: null,
                loading: false,
                error: null,
            },
            companyManagement: {
                companies: [],
                invoices: [],
                loading: false,
                invoicesLoading: false,
                error: null,
            },
            categoryManagement: {
                categories: [],
                loading: false,
                saving: false,
                error: null,
            },
            configurations: {
                groups: [],
                loading: false,
                error: null,
            },
            contactMessage: {
                messages: [],
                loading: false,
                error: null,
            },
            ideasOccasionsManagement: {
                occasions: [],
                giftPurposes: [],
                industries: [],
                loading: false,
                saving: false,
                error: null,
            },
            myVerification: {
                status: null,
                statusLoading: false,
                submitting: false,
                error: null,
                supplierTypes: [],
                capabilities: [],
                manufacturingMaterials: [],
                lookupsLoading: false,
            },
            newsletterSubscriber: {
                subscribers: [],
                loading: false,
                error: null,
            },
            supplierVerificationManagement: {
                applications: [],
                selectedDetail: null,
                supplierTypes: [],
                capabilities: [],
                manufacturingMaterials: [],
                loading: false,
                detailLoading: false,
                saving: false,
                error: null,
            },
            quotes: {
                items: [],
                totalCount: 0,
                pageNumber: 1,
                pageSize: 20,
                loading: false,
                error: null,
                searchQuery: null,
                statusFilter: null,
                actingId: null,
            },
            quoteDetail: {
                quote: null,
                messages: [],
                totalMessages: 0,
                messagesPage: 1,
                loading: false,
                messagesLoading: false,
                sending: false,
                actingId: null,
                error: null,
            },
            products: {
                items: [],
                totalCount: 0,
                pageNumber: 1,
                pageSize: 20,
                loading: false,
                error: null,
                brandingMethods: [],
                keywords: [],
                colors: [],
                materials: [],
                categories: [],
                optionsLoading: false,
                creating: false,
            },
            userManagement: {
                users: [],
                loading: false,
                error: null,
            },
        };
    }
    return next(state, action);
}

export const provideStateLogoutPlugin = (): EnvironmentProviders => withNgxsPlugin(logoutPlugin);
